module.exports = cfp.vendors["react/jsx-runtime@18"];